import { hasClerkErrorCode } from '@/lib/auth/clerk-error-code';

/** After OAuth popup/sheet closes, parent window focus returns — recover quickly. */
export const OAUTH_PENDING_FOCUS_RECOVERY_MS = 400;

/** Last-resort clear if Clerk never resolves the pending `signIn.sso()` call. */
export const OAUTH_PENDING_STALL_MS = 20_000;

const OAUTH_USER_CANCELLED_CODES = [
  'oauth_access_denied',
  'oauth_cancelled',
  'oauth_canceled',
  'auth_cancelled',
  'auth_canceled',
  'user_denied',
  'authorization_denied',
] as const;

export function isOAuthUserCancelledError(error: unknown): boolean {
  if (hasClerkErrorCode(error, OAUTH_USER_CANCELLED_CODES)) {
    return true;
  }
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (message.includes('popup') && message.includes('closed')) return true;
    if (message.includes('user') && message.includes('cancel')) return true;
    if (message.includes('access_denied')) return true;
  }
  return false;
}

export function isOAuthPendingMethod(
  method: 'google' | 'apple' | null,
): method is 'google' | 'apple' {
  return method === 'google' || method === 'apple';
}
